import { gql } from "@apollo/client";

export const UPDATE_NEWS_GENERATION_RECORD_MUTATION = gql`
  mutation UpdateNewsArticle($input: NewsArticleUpdateInput!) {
    updateNewsArticle(input: $input) {
      newsId
      title
      content
      source
      url
      publishedDate
      status
      score
      enrichedData
      timestamp
      tenantId
    }
  }
`;
